import React from 'react'
import { ImportBucket } from '../model/imports.state.types'
import { Source } from '@/app/constants/import/source'
import { FaIcon, faPeopleArrows, faPeopleAssigned } from '@/lib/fa'
import {
  getSourceIcon,
  getStatusLabel,
  getStatusPillClasses,
} from '../pages/home/components/import-review/utils'
import { getSourceName } from '@/app/common/converters/import/sourceToTextConverter'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import clx from 'classnames'
import { Checkbox } from '@/ui'

type VehicleRowProps = {
  checked?: boolean
  onCheck?: (checked: boolean) => void

  registrationNumber: string
  status: ImportBucket
  sources: Source[]

  onBind?: () => void
  className?: string

  assigned?: boolean
  handleAssign?: () => void
}

export const VehicleRow: React.FC<VehicleRowProps> = ({
  checked = false,
  onCheck,
  registrationNumber,
  status,
  sources,
  onBind,
  className,
  assigned,
  handleAssign,
}) => {
  const { t } = useLocalize()
  const allowChange = status !== 'existing'

  return (
    <div
      className={clx(
        'tw-grid tw-items-center tw-px-4 tw-py-2.5 tw-text-sm hover:tw-bg-slate-50',
        className,
      )}
    >
      {/* Checkbox */}
      <div className="tw-flex tw-items-center tw-justify-center">
        <Checkbox
          className="tw-h-4 tw-w-4 tw-rounded tw-border-slate-300 tw-text-blue-600 focus:tw-ring-blue-500"
          checked={checked}
          onChange={(e) => onCheck?.(e.target.checked)}
          disabled={!allowChange}
          readOnly={!allowChange}
        />
      </div>

      {/* Registration number */}
      <div className="tw-font-medium tw-text-slate-900">
        {registrationNumber}
      </div>

      {/* Status */}
      <div>
        <span
          className={clx(
            'tw-inline-flex tw-items-center tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium',
            getStatusPillClasses(status),
          )}
        >
          {getStatusLabel(status, t)}
        </span>
      </div>

      {/* Source */}
      <div className="tw-flex tw-flex-col tw-gap-1 tw-text-sm tw-text-slate-700">
        {sources.map((s, i) => (
          <span key={i}>
            <FaIcon icon={getSourceIcon(s)} /> {getSourceName(s, t)}
          </span>
        ))}
      </div>

      {/* Bind */}
      <div className="tw-flex tw-text-blue-600" onClick={handleAssign}>
        <FaIcon icon={assigned ? faPeopleAssigned : faPeopleArrows} />
      </div>

      {/* Range */}
      <div>
        {/* {status === 'new' ? (
          <button
            type="button"
            className="tw-flex tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-gray-200 tw-px-3 tw-py-1.5 tw-text-sm hover:tw-bg-gray-100"
          >
            Wczytaj od
            <span className="tw-text-gray-400">Ustaw…</span>
          </button>
        ) : (
          <span className="tw-text-slate-400">-</span>
        )} */}
      </div>
    </div>
  )
}
